import { z } from 'zod';
import { severitySchema } from './shared/severity';
export const bucketTypeSchema = z.enum([
    'minutes',
    'hours',
    'days',
    'months',
    'years',
]);
export const organizationDashboardAlertsHistoryResponseSchema = z.object({
    history: z.array(z.object({
        date: z.string(),
        label: z.string(),
        count: z.number(),
    })),
    meta: z.object({
        total: z.number(),
        bucketType: bucketTypeSchema,
    }),
});
// Three-series usage history:
//   coveredActive : covered > 0 & supported = 0
//   coverageGaps  : covered > 0 & supported > 0
//   totalUsers    : cumulative count of org members who had joined by the
//                   bucket (a headcount ceiling that steps up as people join)
// meta.{current,previous}Coverage track the coveredActive line only.
export const organizationDashboardUsageHistoryResponseSchema = z.object({
    history: z.array(z.object({
        date: z.string(),
        coveredActive: z.number(),
        coverageGaps: z.number(),
        totalUsers: z.number(),
    })),
    meta: z.object({
        total: z.number(),
        currentCoverage: z.number(),
        previousCoverage: z.number(),
        // Total activated users (matches the Inventory Users tab count); the
        // headline for the "Total Users" line and its rightmost value.
        totalUsers: z.number(),
        bucketType: bucketTypeSchema,
    }),
});
// Top alerts summary for the organization dashboard
// Aggregated per alert title with user counts.
export const organizationDashboardTopAlertSchema = z.object({
    // Composite `<subPolicyKey>::<type>` title key — the same identity the
    // Alerts page groups and filters on, so a widget row deep-links straight
    // to the Title filter. Render with `formatTopAlertLabel(alertName,
    // revampEnabled)`, never raw: with `alerts_revamp` off the row must show
    // the plain Type label, so the composite title formatter is wrong there.
    alertName: z.string(),
    // Highest observed risk level for this alert within the aggregation window
    riskLevel: severitySchema,
    // Maximum score among scans contributing to this alert
    maxScore: z.number().int().min(0).max(100),
    // Total issues across all scans contributing to this alert
    issuesCount: z.number().int().min(0),
    // Distinct users who triggered this alert within the aggregation window
    userCount: z.number().int().min(0),
});
export const organizationDashboardTopAlertsResponseSchema = z.object({
    alerts: z.array(organizationDashboardTopAlertSchema),
    meta: z.object({
        // Total number of distinct alerts available (before limiting)
        total: z.number().int().min(0),
    }),
});
/**
 * KIR-5693: the range the dashboard's time-ranged widgets open on. `1d` for an
 * organization with so many recent findings that 7-day views are slow to
 * build; `7d` otherwise. Only the opening default: any range can be chosen.
 */
export const dashboardDefaultRangeResponseSchema = z.object({
    defaultRange: z.enum(['1d', '7d']),
});
//# sourceMappingURL=organization-dashboard.js.map